'use client';

// Fase 7 · K4 · Link "Entrar" / CTA da landing que dispara InitiateCheckout
// ANTES do redirect pra app.trakd.pro/entrar.
//
// Não faz preventDefault → deixa o browser seguir o href naturalmente.
// O helper `initiateCheckout` é fire-and-forget (a queue do tracker chama
// sendBeacon no unload pra garantir entrega). Se o tracker ainda não
// inicializou, é no-op silencioso.

import type { CSSProperties, ReactNode } from 'react';

import { initiateCheckout } from '@/lib/tracking/dispatch';

interface Props {
  href: string;
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  contentName: string;
  contentCategory?: string;
  target?: string;
  rel?: string;
}

export function EntrarLinkClient({
  href,
  children,
  className,
  style,
  contentName,
  contentCategory = 'auth',
  target,
  rel,
}: Props) {
  return (
    <a
      href={href}
      className={className}
      style={style}
      target={target}
      rel={rel}
      onClick={() => {
        initiateCheckout({
          content_name: contentName,
          content_category: contentCategory,
        });
      }}
    >
      {children}
    </a>
  );
}
